export default __webpack_public_path__ + "static/media/playstore.e42a7dad.png";